<template>
  <div>
    <Title>申领物料清单</Title>
    <a-table bordered :data-source="list" :pagination="false">
      <a-table-column title="商品名称" data-index="name"> </a-table-column>
        <a-table-column title="规格型号" data-index="spec"> </a-table-column>
        <a-table-column title="颜色" data-index="color"> </a-table-column>

        <a-table-column title="单位" data-index="unit" align="center">
        </a-table-column>
        <a-table-column title="单价" data-index="price" align="center">
        </a-table-column>
        <a-table-column title="数量" align="center" data-index="num">

        </a-table-column>
        <a-table-column title="备注" data-index="remark"> </a-table-column>
    </a-table>
  </div>
</template>

<script>
import Title from "../Title";
import { mapState } from "vuex";

export default {
  components: {
    Title,
  },

  computed: {
    ...mapState("approval", ["detail"]),

    list() {
      const rawList = this.detail.extra?.subList;
      if (!rawList) return [];

      // 处理字符串和数组两种格式
      if (typeof rawList === 'string') {
        try {
          const parsed = JSON.parse(rawList);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.error('subList JSON parse error:', e);
          return [];
        }
      }
      return Array.isArray(rawList) ? rawList : [];
    },
  },
};
</script>